import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __assign, __extends } from "tslib";
import { Component } from 'react';
import PropTypes from 'prop-types';
import DateTHead from './DateTHead';
import DateTBody from './DateTBody';
injectStyle("components/DatePicker/rc-calendar/style/common/DateTable.css", "[data-dui-0-122-5~=\"dui-calendar-table\"]{margin-bottom:0;border-spacing:0}[data-dui-0-122-5~=\"dui-calendar\"] table{width:100%;max-width:100%;border-collapse:collapse}[data-dui-0-122-5~=\"dui-calendar\"] table,[data-dui-0-122-5~=\"dui-calendar\"] td,[data-dui-0-122-5~=\"dui-calendar\"] th{border:none}");
var DateTable = (function (_super) {
    __extends(DateTable, _super);
    function DateTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTable.prototype.render = function () {
        var props = this.props;
        var prefixCls = props.prefixCls;
        return (h("table", { cellSpacing: "0", className: prefixCls + "-table", role: "grid" },
            h(DateTHead, __assign({}, props)),
            h(DateTBody, __assign({}, props))));
    };
    return DateTable;
}(Component));
DateTable.propTypes = {
    prefixCls: PropTypes.string,
};
DateTable.defaultProps = {
    prefixCls: '',
};
export default DateTable;
